import request from "@/utils/request";

// 获取申请车辆信息
export function getApplicationVehicleByApplicationId(applicationId) {
  return request({
    url: "/cloud/application/vehicle?applicationId=" + applicationId,
    method: "get"
  });
}

// 获取车辆安全员信息
export function getSecurityUserListByApplicationId(applicationId) {
  return request({
    url: "/cloud/application/securityUser?applicationId=" + applicationId,
    method: "get"
  });
}

